import { bool, string } from "prop-types";
import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import { useEstimateEditorSettings, useEstimateStructure } from "@tools";
import {
  CostCell,
  HoursCell,
  RateCell,
  TeamCell,
  TimeCell,
  ProfitabilityCell,
  ProfitCell,
  UnitCostCell,
  CompanyCostCell,
} from "./cells";

export const HeaderColumnFactory = observer((cellProps) => {
  const structure = useEstimateStructure();
  const { isSellerOrClient } = useEstimateEditorSettings();
  const { settings, visibility, hideAllPrices } = structure;
  const { currency, companyCurrency, hasTeamMembersCol, hasTimeCol } = settings;
  const {
    apply,
    hideSummaryTime,
    hideSummaryTeam,
    hideSummaryHours,
    hideSummaryRate,
    hideSummaryCost,
  } = visibility;

  switch (cellProps.columnName) {
    case SummaryColumns.TEAM:
      return (apply && hideSummaryTeam) || !hasTeamMembersCol
        ? <></>
        : <TeamCell {...cellProps} />
    
    case SummaryColumns.TIME:
      return (apply && hideSummaryTime) || !hasTimeCol
        ? <></>
        : <TimeCell {...cellProps} />
    
    case SummaryColumns.RATE:
      return (apply && hideSummaryRate) || !isSellerOrClient || hideAllPrices
        ? <></>
        : <RateCell {...cellProps} />
    
    case SummaryColumns.HOURS:
      return apply && hideSummaryHours
        ? <></>
        : <HoursCell {...cellProps} />
    case SummaryColumns.COST:
      return (apply && hideSummaryCost) || !isSellerOrClient || hideAllPrices
        ? <></>
        : <CostCell {...cellProps} />
      
    case SummaryColumns.C_COST:
      return isSellerOrClient
        && <CompanyCostCell {...cellProps} fieldName="pt-profit" />
    
    case SummaryColumns.C_UNIT_COST_INNER:
      return <UnitCostCell {...cellProps} company />
      
    case SummaryColumns.C_UNIT_COST:
      return currency === companyCurrency
        ? <></>
        : <UnitCostCell {...cellProps} />
    
    case SummaryColumns.C_PROFIT:
      return <ProfitCell {...cellProps} />
    
    case SummaryColumns.C_PROFITABILITY:
      return <ProfitabilityCell {...cellProps} />
  }
});

HeaderColumnFactory.propTypes = {
  columnName: string,
  extendPadding: bool,
};
